/* qeslint-disable */
// q@ts-nocheck

import type { PanelManager } from "./panels";
import { deleteFinishCancelButtons, triggerShowingAnnontationsPopup } from "./project/common";
import { showAnnotationDetailAndFly } from "./project/showAnnotaionDetailAndFly";
import { removeActiveClassFromAllAnnotationToolButtons } from "./annotationTools/common";

const BUTTON_TO_PANEL: Record<string, string> = {
    "construkted-popup-info-btn": "info",
    "construkted-popup-transform-btn": "transform",
    "construkted-annontations-popup-btn": "annotations",
    "construkted-popup-asset-manager-btn": "asset-manager",
    "construkted-popup-team-btn": "team",
    "construkted-popup-view-btn": "view",
    "construkted-popup-settings-btn": "settings"
};

function initSidebar(panelManager: PanelManager) {
    jQuery(($) => {
        const sidebarToolButtonsIds = [
            "#construkted-popup-info-btn",
            "#construkted-popup-transform-btn",
            "#construkted-annontations-popup-btn",
            "#construkted-popup-asset-manager-btn",
            "#construkted-annotation-drawing-tools-btn",
            "#construkted-annotation-measurement-tools-btn",
            "#construkted-annotation-clipping-tools-btn",
            "#construkted-popup-team-btn",
            "#construkted-popup-view-btn",
            "#construkted-popup-settings-btn",
            "#sidebar-globe-filter-btn"
        ];

        const sideBarToolButtons = $(sidebarToolButtonsIds.join(","));
        const closeBtn = $(".popup-wrapper .close-btn");

        sideBarToolButtons.on("click", async function () {
            const buttonId = jQuery(this).attr("id");
            const panelId = buttonId ? BUTTON_TO_PANEL[buttonId] : null;

            const canNavigate = await panelManager.canNavigateAway();

            if (!canNavigate) {
                return;
            }

            panelManager.hideAllPopup();
            deleteFinishCancelButtons();
            removeActiveClassFromAllAnnotationToolButtons();
            jQuery("#navbar-right li.nav-item").removeClass("active");

            if (panelId && panelManager.getPanel(panelId)) {
                panelManager.openPanelSync(panelId);
            } else if (buttonId && !jQuery(this).parent().hasClass("active")) {
                const popupID = buttonId.replace("-btn", "");

                jQuery(`#${popupID}`).show();
            }

            $(this).parent().toggleClass("active").siblings().removeClass("active");

            if (window.construktedAssetViewer) {
                window.construktedAssetViewer.tryDeactivateVisualPositionEditor();
            }
        });

        closeBtn.click(async function () {
            const canNavigate = await panelManager.canNavigateAway();

            if (!canNavigate) {
                return;
            }

            jQuery(this).parents(".popup-wrapper").hide();
            jQuery("#navbar-right li.nav-item").removeClass("active");
            jQuery(".transform-has-modal-next").next().addClass("hidden");

            const popupName = $(this).parents(".popup-wrapper").attr("id");

            if (popupName === "sidebar-new-annotation") {
                triggerShowingAnnontationsPopup();
            }

            if (window.construktedAssetViewer) {
                window.construktedAssetViewer.tryDeactivateVisualPositionEditor();
            }
        });
    });

    jQuery("#scroll-down-btn").on("click", () => {
        const toScroll =
            // @ts-ignore
            jQuery(".post-meta").offset().top -
            // @ts-ignore
            jQuery(".featured-image").height() -
            // @ts-ignore
            jQuery("#header").height() +
            // @ts-ignore
            jQuery(".post-meta").height();

        $("html, body").animate({ scrollTop: toScroll }, 600);
    });

    jQuery(window).on("scroll", () => {
        // @ts-ignore
        if (jQuery(window).scrollTop() > 200) {
            jQuery("#scroll-down-btn").fadeOut(300);
        } else {
            jQuery("#scroll-down-btn").fadeIn(300);
        }
    });

    jQuery(".embed-code-link").on("click", () => {
        jQuery(".embed-content").toggleClass("in");

        return false;
    });

    jQuery(document).on("click", ".variation-action", function () {
        const currentItem = jQuery(this);
        const currentValue = jQuery(this).attr("data-value");

        // @ts-ignore
        jQuery(".variations #disk_space").val(currentValue).trigger("change");

        currentItem.parent().addClass("selected").siblings().removeClass("selected");
    });

    jQuery(document).ready(() => {
        if (jQuery("table.variations").length > 0) {
            const defaultValue = jQuery("#disk_space").val();

            jQuery(`.variation-action[data-value="${defaultValue}"]`).trigger("click");

            const currentSubValue = jQuery(".flex-row").data("current");

            if (currentSubValue > 0) {
                jQuery(`.variation-action[data-value="${currentSubValue}"]`).trigger("click");
            }
        }
    });

    jQuery(document).on(
        "click",
        ".annotation-line-item .annotation-title, .annotation-line-item .view-annotation",
        function () {
            const id = jQuery(this).parents(".annotation-line-item").attr("data-entity-id");

            if (id) {
                showAnnotationDetailAndFly(id);
            }
        }
    );
}

export { initSidebar };
